import {
    apiRequest,
    bobotPenilaianIndividuCreate, 
    bobotPenilaianIndividuUpdate,
    bobotPenilaianIndividuCriteriaList
} from "../../../../../../services/adapters/master/bobotPenilaianIndividuService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", bobotPenilaianIndividuCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotPenilaianIndividuUpdate, {
            body: query
        }, true)
    }
    
    // fetchCriteriaList = async (query, cancelToken) => {
    //     return await apiRequest("get", bobotPenilaianIndividuCriteriaList, {
    //         cancelToken: cancelToken,
    //         params: query
    //     }, true)
    // }

}

export default CreateRepository